import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import FinancialAid from './FinancialAid';
import FieldPayment from './FieldPayment';
import FeePayment from './FeePayment';
import Insurance from './Insurance';
import PermissionSplash from 'components/PermissionSplash';

export default class Financial extends React.Component {
	render() {
		let routeProps = this.props;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'Payments' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/financial/Financial Aid" render={() => <FinancialAid {...routeProps} />} />
					<Route path="/portal/financial/Field Payment Status" render={() => <FieldPayment {...routeProps} />} />
					<Route path="/portal/financial/Program Fee Payment Status" render={() => <FeePayment {...routeProps} />} />
					<Route path="/portal/financial/Insurance Opt-out" render={() => <Insurance {...routeProps} />} />
					<Route path="*" render={() => (
						<Redirect to="/portal/financial/Program Fee Payment Status" />
					)} />
				</Switch>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/index.jsx